"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioColor_1 = require("./RadioColor");
exports.default = RadioColor_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioColor/index.js
// module id = 939
// module chunks = 8